module.exports = __webpack_public_path__ + "static/media/DSCF6369.4f9f834b.jpg";